var profiles = {"basePath":"https://en.shmet.com/api","ssoPath":"https://en.shmet.com/sso"}; module.exports = profiles


//////////////////
// WEBPACK FOOTER
// ./config/profiles.js
// module id = rte0
// module chunks = 25